import xianlu from './map/xianlu.png'
import youju from './map/youju.png'
import chongdianzhuang from './map/chongdianzhuang.png'
import chetou from './map/chetou.png'
import guaxiang from './map/guaxiang.png'
import zhengche from './map/zhengche.png'

export {
  xianlu,
  youju,
  chongdianzhuang,
  chetou,
  guaxiang,
  zhengche,
}

export default {
  xianlu,
  youju,
  chongdianzhuang,
  chetou,
  guaxiang,
  zhengche,
}